export const SET_PROFILE = "customer/SET_PROFILE";
export const SET_CHECKED = "customer/SET_CHECKED";
